var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLumenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "37px",
    viewBox: "0 0 100 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create_User",
    transform: "translate(-24.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(24.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#55555A",
    points: "0 12.9464286 1.79432473 12.9464286 1.79432473 21.5421302 6.25 21.5421302 6.25 23.2142857 0 23.2142857 0 12.9464286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0891088,12.9464286 L21.875,12.9464286 L21.875,19.658023 C21.875,21.9748191 20.3126106,23.6607143 17.8570101,23.6607143 C15.4019406,23.6607143 13.8392857,21.9748191 13.8392857,19.658023 L13.8392857,12.9464286 L15.625177,12.9464286 C15.625177,12.9464286 15.625177,15.9564436 15.625177,19.4321892 C15.625177,20.9369209 16.3692098,21.9453146 17.8570101,21.9453146 C19.330742,21.9453146 20.0891088,20.9369209 20.0891088,19.4321892 C20.0891088,15.9564436 20.0891088,12.9464286 20.0891088,12.9464286",
    id: "Fill-2",
    fill: "#55555A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#55555A",
    points: "32.038153 12.9464286 35.4912065 18.1099243 38.9437198 12.9464286 40.625 12.9464286 40.625 23.2142857 38.807575 23.2142857 38.807575 16.3200379 35.4912065 21.2047962 32.1742978 16.3200379 32.1742978 23.2142857 30.3571429 23.2142857 30.3571429 12.9464286 32.038153 12.9464286"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#55555A",
    points: "50.9762431 17.1121681 55.3360881 17.1121681 55.3360881 18.7843236 50.9762431 18.7843236 50.9762431 21.5421302 55.8035714 21.5421302 55.8035714 23.2142857 49.1071429 23.2142857 49.1071429 12.9464286 55.7102414 12.9464286 55.7102414 14.6188528 50.9762431 14.6188528 50.9762431 17.1121681"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#55555A",
    points: "65.0615224 12.9464286 70.4681521 20.0164664 70.4681521 12.9464286 72.3214286 12.9464286 72.3214286 23.2142857 70.6535899 23.2142857 65.2466847 16.1587626 65.2466847 23.2142857 63.3928571 23.2142857 63.3928571 12.9464286 65.0615224 12.9464286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2093211,18.2712505 L82.2805212,18.2712505 L91.93553,4.03217058 L90.6814032,15.2888152 C90.6560004,15.5155169 90.7313805,15.7446447 90.8871109,15.915008 C91.0425652,16.0851017 91.2673251,16.1837614 91.5011968,16.1848397 L97.7375919,16.2126046 L88.1684557,32.3275672 L88.8963021,23.0581346 C88.931369,22.612818 88.5898114,22.2241094 88.1336649,22.1901446 C87.6775184,22.1559102 87.2793566,22.4893585 87.2445658,22.9346752 L86.2392211,35.7364498 C86.2094004,36.1138368 86.4493467,36.4583372 86.8196206,36.570475 C87.1898945,36.6826129 87.5872279,36.531119 87.7818909,36.2038705 L99.8879968,15.8158091 C100.036548,15.565925 100.037377,15.2586242 99.8902058,15.008201 C99.743035,14.7575082 99.471059,14.6027796 99.1753369,14.6014318 L92.4275718,14.5715104 L93.9514655,0.896354431 C93.9926071,0.524897829 93.7692278,0.175275759 93.4091703,0.0483119998 C93.0493889,-0.0786517589 92.648466,0.051007621 92.4372359,0.36235187 L80.0481093,18.633542 C79.8802297,18.8807304 79.8650432,19.2012398 80.0089006,19.462715 C80.1527579,19.7239207 80.4346741,19.8886232 80.7386797,19.8886232 L88.2093211,19.8886232 C88.6668482,19.8886232 89.0376743,19.5263317 89.0376743,19.0799368 C89.0376743,18.6332724 88.6668482,18.2712505 88.2093211,18.2712505",
    id: "Fill-6",
    fill: "#F8DA1E"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumenLogo);
export default __webpack_public_path__ + "static/media/lumen_logo.e36f98212f291f1b22a4a1a2a10abe5b.svg";
export { ForwardRef as ReactComponent };